import React from 'react';
import { observer } from 'mobx-react';
import { AutoSizer, Grid, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import groups from '../../Mobx/Groups';
import dictionary from '../../Mobx/Dictionary';
import CategoryCard from './CategoryCard';

const CategoryList = observer(() => {
    const dictionaryType = dictionary.current.dictionaryType;
    const categories = groups.categories[dictionaryType];

    if (!categories || categories.length === 0) {
        return <div>No categories available</div>;
    }

    const cardWidth = 300; // רוחב הכרטיסים בפיקסלים

    // יצירת cache לגובה דינמי של התאים
    const cache = new CellMeasurerCache({
        defaultHeight: 150,
        fixedWidth: true,
    });

    const cellRenderer = ({ columnIndex, key, rowIndex, style, parent }) => {
        const index = rowIndex * Math.floor(parent.props.width / cardWidth) + columnIndex;
        if (index >= categories.length) {
            return null;
        }

        const item = categories[index];

        return (
            <CellMeasurer
                key={key}
                cache={cache}
                columnIndex={columnIndex}
                rowIndex={rowIndex}
                parent={parent}
            >
                <div style={{ ...style, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CategoryCard category={item} />
                </div>
            </CellMeasurer>
        );
    };

    return (
        <AutoSizer key={`${dictionaryType}-${categories.length}`}>
            {({ width, height }) => {
                const columnCount = Math.floor(width / cardWidth);
                return (
                    <Grid
                        style={{ padding: '5px' }}
                        width={width}
                        height={height}
                        columnCount={columnCount}
                        columnWidth={cardWidth}
                        rowCount={Math.ceil(categories.length / columnCount)}
                        rowHeight={cache.rowHeight}
                        cellRenderer={cellRenderer}
                        deferredMeasurementCache={cache}
                        scrollToRow={0}
                    />
                );
            }}
        </AutoSizer>
    );
});

export default CategoryList;
